// NOTE This file is auto-generated by generated-site-data.mjs

export default [
  {
    id: "ruby",
    name: "Ruby (on Rails) APM",
    shortName: "Ruby",
    link: "https://www.appsignal.com/ruby",
    icon: "gem",
    styles: {
      text: "text-red-500",
      box: "c_h-icon-box--red",
    },
    description:
      "Our monitoring gem provides Ruby on Rails error tracking, performance monitoring, server monitoring and more.",
    frameworks: [
      {
        id: "active-record",
        name: "Active Record",
        link: "https://www.appsignal.com/ruby/active-record-monitoring",
        description: "A powerful ORM for Ruby",
      },
      {
        id: "capistrano",
        name: "Capistrano",
        link: "https://www.appsignal.com/ruby/capistrano-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/capistrano.html",
        description: "A remote server automation and deployment tool",
      },
      {
        id: "delayed-job",
        name: "Delayed::Job",
        link: "https://www.appsignal.com/ruby/delayed-job-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/delayed-job.html",
        description: "Async execution of background tasks",
      },
      {
        id: "garbage-collection",
        name: "Garbage Collection",
        link: "https://www.appsignal.com/ruby/garbage-collection-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/garbage-collection.html",
      },
      {
        id: "global-vm-lock",
        name: "Global VM Lock",
        link: "https://www.appsignal.com/ruby/global-vm-lock-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/global-vm-lock.html",
        description: "HTTP Toolkit for Ruby",
      },
      {
        id: "grape",
        name: "Grape",
        link: "https://www.appsignal.com/ruby/grape-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/grape.html",
        description: "A REST-like API framework for Ruby",
      },
      {
        id: "graphql",
        name: "GraphQL",
        link: "https://www.appsignal.com/ruby/graphql-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/graphql.html",
        description: "A REST-like API framework for Ruby",
      },
      {
        id: "hanami",
        name: "Hanami",
        link: "https://www.appsignal.com/ruby/hanami-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/hanami.html",
      },
      {
        id: "mongo-db",
        name: "MongoDB",
        link: "https://www.appsignal.com/ruby/mongodb-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/mongodb.html",
        description: "A document-oriented NoSQL database",
      },
      {
        id: "padrino",
        name: "Padrino",
        link: "https://www.appsignal.com/ruby/padrino-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/padrino.html",
        description: "Web framework built on Sinatra",
      },
      {
        id: "puma",
        name: "Puma",
        link: "https://www.appsignal.com/ruby/puma-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/puma.html",
      },
      {
        id: "que",
        name: "Que",
        link: "https://www.appsignal.com/ruby/que-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/que.html",
      },
      {
        id: "ruby-on-rails",
        name: "Ruby on Rails",
        link: "https://www.appsignal.com/ruby/rails-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/rails.html",
        description: "The most popular Ruby framework",
      },
      {
        id: "rake",
        name: "Rake",
        link: "https://www.appsignal.com/ruby/rake-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/rake.html",
        description: "A Make-like program implemented in Ruby",
      },
      {
        id: "resque",
        name: "Resque",
        link: "https://www.appsignal.com/ruby/resque-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/resque.html",
        description: "Redis-backed library for creating background jobs",
      },
      {
        id: "shoryuken",
        name: "Shoryuken",
        link: "https://www.appsignal.com/ruby/shoryuken-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/shoryuken.html",
        description: "Efficient Amazon SQS thread-based message processor",
      },
      {
        id: "sidekiq",
        name: "Sidekiq",
        link: "https://www.appsignal.com/ruby/sidekiq-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/sidekiq.html",
        description: "Simple, efficient background processing",
      },
      {
        id: "sinatra",
        name: "Sinatra",
        link: "https://www.appsignal.com/ruby/sinatra-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/sinatra.html",
        description: "DSL for quickly creating web applications",
      },
      {
        id: "solid-queue",
        name: "Solid Queue",
        link: "https://www.appsignal.com/ruby/solid-queue-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/solidqueue.html",
        description:
          "SolidQueue manages tasks in the background for efficient processing across multiple workers.",
      },
      {
        id: "view-component",
        name: "ViewComponent",
        link: "https://www.appsignal.com/ruby/view-component-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/view-component.html",
        description:
          "A framework for building reusable, testable, view components.",
      },
      {
        id: "webmachine",
        name: "Webmachine",
        link: "https://www.appsignal.com/ruby/webmachine-monitoring",
        docs: "https://docs.appsignal.com/ruby/integrations/webmachine.html",
        description: "HTTP Toolkit for Ruby",
      },
    ],
  },
  {
    id: "elixir",
    name: "Elixir APM",
    shortName: "Elixir",
    link: "https://www.appsignal.com/elixir",
    icon: "droplet",
    styles: {
      text: "text-purple-500",
      box: "c_h-icon-box--purple",
    },
    description:
      "Our monitoring package provides Elixir error tracking, performance monitoring, server monitoring and more.",
    frameworks: [
      {
        id: "absinthe",
        name: "Absinthe",
        link: "https://www.appsignal.com/elixir/absinthe-monitoring",
        docs: "https://docs.appsignal.com/elixir/integrations/absinthe.html",
        description: "Toolkit for building a GraphQL API with Elixir.",
      },
      {
        id: "ecto",
        name: "Ecto",
        link: "https://www.appsignal.com/elixir/ecto-monitoring",
        docs: "https://docs.appsignal.com/elixir/integrations/ecto.html",
        description: "Toolkit for data mapping and language integrated queries",
      },
      {
        id: "erlang",
        name: "Erlang",
        link: "https://www.appsignal.com/elixir/erlang-monitoring",
        docs: "https://docs.appsignal.com/elixir/integrations/erlang.html",
        description: "Virtual machine",
      },
      {
        id: "finch",
        name: "Finch",
        link: "https://www.appsignal.com/elixir/finch-monitoring",
        docs: "https://docs.appsignal.com/elixir/integrations/finch.html",
      },
      {
        id: "oban",
        name: "Oban",
        link: "https://www.appsignal.com/elixir/oban-monitoring",
        docs: "https://docs.appsignal.com/elixir/integrations/oban.html",
      },
      {
        id: "phoenix",
        name: "Phoenix",
        link: "https://www.appsignal.com/elixir/phoenix-monitoring",
        docs: "https://docs.appsignal.com/elixir/integrations/phoenix.html",
        description: "MVC Web development framework",
      },
      {
        id: "plug",
        name: "Plug",
        link: "https://www.appsignal.com/elixir/plug-monitoring",
        docs: "https://docs.appsignal.com/elixir/integrations/plug.html",
        description:
          "Specification for composable modules in between web applications",
      },
      {
        id: "tesla",
        name: "Tesla",
        link: "https://www.appsignal.com/elixir/tesla-monitoring",
        docs: "https://docs.appsignal.com/elixir/integrations/tesla.html",
      },
    ],
  },
  {
    id: "nodejs",
    name: "Node.js APM",
    shortName: "Node.js",
    link: "https://www.appsignal.com/nodejs",
    icon: ["fab", "node-js"],
    styles: {
      text: "text-green-500",
      box: "c_h-icon-box--green",
    },
    description:
      "Our monitoring package provides Node.js error tracking, performance monitoring, server monitoring and more.",
    frameworks: [
      {
        id: "amqplib",
        name: "AMQPlib",
        link: "https://www.appsignal.com/nodejs/amqplib-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/amqplib.html",
      },
      {
        id: "apollo-gateway",
        name: "Apollo Gateway",
        link: "https://www.appsignal.com/nodejs/apollo-gateway-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/apollo-gateway.html",
      },
      {
        id: "bullmq",
        name: "BullMQ",
        link: "https://www.appsignal.com/nodejs/bullmq-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/bullmq.html",
      },
      {
        id: "express",
        name: "Express",
        link: "https://www.appsignal.com/nodejs/express-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/express.html",
        description: "Automatic instrumentation and error-catching for Express",
      },
      {
        id: "fastify",
        name: "Fastify",
        link: "https://www.appsignal.com/nodejs/fastify-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/fastify.html",
      },
      {
        id: "graphql",
        name: "GraphQL",
        link: "https://www.appsignal.com/nodejs/graphql-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/graphql.html",
      },
      {
        id: "knexjs",
        name: "Knex.js",
        link: "https://www.appsignal.com/nodejs/knexjs-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/knexjs.html",
      },
      {
        id: "koa",
        name: "Koa",
        link: "https://www.appsignal.com/nodejs/koa-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/koajs.html",
        description:
          "automatically instrumenting the middlewares or routes of your Koa application",
      },
      {
        id: "mongodb",
        name: "MongoDB",
        link: "https://www.appsignal.com/nodejs/mongodb-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/mongo.html",
      },
      {
        id: "mongoose",
        name: "Mongoose",
        link: "https://www.appsignal.com/nodejs/mongoose-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/mongoose.html",
      },
      {
        id: "mysql",
        name: "MySQL",
        link: "https://www.appsignal.com/nodejs/mysql-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/mysql.html",
      },
      {
        id: "nestjs",
        name: "NestJS",
        link: "https://www.appsignal.com/nodejs/nestjs-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/nestjs.html",
      },
      {
        id: "nextjs",
        name: "Next.js",
        link: "https://www.appsignal.com/nodejs/nextjs-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/nextjs.html",
        description:
          "Instrument your Next.js requests and get experimental web vitals reporting.",
      },
      {
        id: "pino",
        name: "Pino",
        link: "https://www.appsignal.com/nodejs/pino-monitoring",
        docs: "https://docs.appsignal.com/logging/platforms/integrations/nodejs.html#usage-with-pino",
        description: "Auto-instrument Pino logs.",
      },
      {
        id: "postgresql",
        name: "PostgreSQL",
        link: "https://www.appsignal.com/nodejs/postgresql-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/pg.html",
        description:
          "Get insights into query duration, (sanitized) SQL queries, and errors",
      },
      {
        id: "prisma",
        name: "Prisma",
        link: "https://www.appsignal.com/nodejs/prisma-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/prisma.html",
      },
      {
        id: "redis",
        name: "Redis",
        link: "https://www.appsignal.com/nodejs/redis-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/redis.html",
        description: "Auto-instrument Redis",
      },
      {
        id: "remix",
        name: "Remix",
        link: "https://www.appsignal.com/nodejs/remix-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/remix.html",
        description: "Auto-instrument Remix",
      },
      {
        id: "restify",
        name: "Restify",
        link: "https://www.appsignal.com/nodejs/restify-monitoring",
        docs: "https://docs.appsignal.com/nodejs/3.x/integrations/restify.html",
        description: "Auto-instrument Restify",
      },
      {
        id: "winston",
        name: "Winston",
        link: "https://www.appsignal.com/nodejs/winston-monitoring",
        docs: "https://docs.appsignal.com/logging/platforms/integrations/nodejs.html",
        description: "Auto-instrument Winston logs",
      },
    ],
  },
  {
    id: "javascript",
    name: "JavaScript Error Tracking",
    shortName: "JavaScript",
    link: "https://www.appsignal.com/javascript",
    icon: ["fab", "js-square"],
    styles: {
      text: "text-yellow-500",
      box: "c_h-icon-box--yellow",
    },
    description:
      "Our JS package provides easy to use use error tracking. Together with our back-end monitoring, this gives you a full overview of your application.",
    frameworks: [
      {
        id: "react",
        name: "React",
        link: "https://www.appsignal.com/javascript/react-monitoring",
        docs: "https://docs.appsignal.com/front-end/integrations/react.html",
        description:
          "React is a declarative, efficient, and flexible JavaScript library for building user interfaces.",
      },
      {
        id: "vue",
        name: "Vue",
        link: "https://www.appsignal.com/javascript/vue-monitoring",
        docs: "https://docs.appsignal.com/front-end/integrations/vue.html",
        description:
          "Vue.js is a progressive, incrementally-adoptable JavaScript framework for building UI on the web.",
      },
      {
        id: "angular",
        name: "Angular",
        link: "https://www.appsignal.com/javascript/angular-monitoring",
        docs: "https://docs.appsignal.com/front-end/integrations/angular.html",
        description:
          "Angular is a development platform for building mobile and desktop web applications using Typescript/JavaScript and other languages.",
      },
      {
        id: "ember",
        name: "Ember",
        link: "https://www.appsignal.com/javascript/ember-monitoring",
        docs: "https://docs.appsignal.com/front-end/integrations/ember.html",
        description:
          "Ember.js is a JavaScript framework for building modern web applications.",
      },
      {
        id: "preact",
        name: "Preact",
        link: "https://www.appsignal.com/javascript/preact-monitoring",
        docs: "https://docs.appsignal.com/front-end/integrations/preact.html",
        description:
          "Preact is a fast 3kB alternative to React with the same modern API.",
      },
      {
        id: "stimulus",
        name: "Stimulus",
        link: "https://www.appsignal.com/javascript/stimulus-monitoring",
        docs: "https://docs.appsignal.com/front-end/integrations/stimulus.html",
        description:
          "Stimulus is a JavaScript framework with modest ambitions, designed to augment your HTML with just enough behavior to make it shine.",
      },
    ],
  },
  {
    id: "python",
    name: "Python APM",
    shortName: "Python",
    link: "https://www.appsignal.com/python",
    icon: ["fab", "python"],
    styles: {
      text: "text-blue-500",
      box: "c_h-icon-box--blue",
    },
    description:
      "Our Python monitoring package provides Python error tracking, performance monitoring, server monitoring, and more.",
    frameworks: [
      {
        id: "celery",
        name: "Celery",
        link: "https://www.appsignal.com/python/celery-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/celery.html",
      },
      {
        id: "django",
        name: "Django",
        link: "https://www.appsignal.com/python/django-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/django.html",
      },
      {
        id: "fastapi",
        name: "FastAPI",
        link: "https://www.appsignal.com/python/fastapi-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/fastapi.html",
      },
      {
        id: "flask",
        name: "Flask",
        link: "https://www.appsignal.com/python/flask-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/flask.html",
      },
      {
        id: "jinja2",
        name: "Jinja2",
        link: "https://www.appsignal.com/python/jinja2-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/jinja2.html",
      },
      {
        id: "pmysql",
        name: "MySQL",
        link: "https://www.appsignal.com/python/mysql-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/mysql.html",
      },
      {
        id: "pika",
        name: "Pika",
        link: "https://www.appsignal.com/python/pika-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/pika.html",
      },
      {
        id: "psycopg2",
        name: "PostgreSQL",
        link: "https://www.appsignal.com/python/postgresql-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/postgresql.html",
      },
      {
        id: "redis",
        name: "Redis",
        link: "https://www.appsignal.com/python/redis-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/redis.html",
      },
      {
        id: "request",
        name: "Request",
        link: "https://www.appsignal.com/python/request-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/requests.html",
      },
      {
        id: "sqlalchemy",
        name: "SQLAlchemy",
        link: "https://www.appsignal.com/python/sqlalchemy-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/sqlalchemy.html",
      },
      {
        id: "sqlite",
        name: "SQLite",
        link: "https://www.appsignal.com/python/sqlite-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/sqlite.html",
      },
      {
        id: "starlette",
        name: "Starlette",
        link: "https://www.appsignal.com/python/starlette-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/starlette.html",
      },
      {
        id: "wsgi-and-asgi",
        name: "WSGI and ASGI",
        link: "https://www.appsignal.com/python/wsgi-asgi-monitoring",
        docs: "https://docs.appsignal.com/python/instrumentations/wsgi.html",
      },
    ],
  },
];
